// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAk2Y1PdNC9s-DDL25fdtujK5A_TFfisXo",
  authDomain: "marmin-interview-302a9.firebaseapp.com",
  projectId: "marmin-interview-302a9",
  storageBucket: "marmin-interview-302a9.firebasestorage.app",
  messagingSenderId: "817616556060",
  appId: "1:817616556060:web:e58cb25e3bd14bae4ecfd9"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Connect to emulators in development
if (process.env.NODE_ENV === 'development') {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, 'localhost', 8080);
}

export { auth, db };